import React, { useEffect } from "react";
import { Button, Spinner } from "reactstrap";
import { useForm, FieldErrors } from "react-hook-form";
import CommonForm from "../../../../Components/Common/CommonForm";
import { TrainingGroupFormValues } from "../helper/traininggroup.types";
import { trainingGroupFormFields } from "../helper/traininggroupconstant";

/* ---------- Types ---------- */

interface AddEditTrainingGroupProps {
  existingData?: TrainingGroupFormValues | null;
  onSave: (values: TrainingGroupFormValues) => void;
  onCancel: () => void;
  loading: boolean;
}

/* ---------- Component ---------- */

const AddEditTrainingGroup: React.FC<AddEditTrainingGroupProps> = ({
  existingData,
  onSave,
  onCancel,
  loading,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<TrainingGroupFormValues>({
    defaultValues: {
      traininggroup: "",
      description: "",
      ...existingData,
    },
  });

  useEffect(() => {
    if (existingData) {
      reset(existingData);
    }
  }, [existingData, reset]);

  /* -----------------------------------------
   * Submit Handler
   * ----------------------------------------- */

  const onSubmit = (values: TrainingGroupFormValues) => {
    onSave(values);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CommonForm
          fields={trainingGroupFormFields}
          control={control}
          errors={errors as FieldErrors}
          columns={1}
          setValue={setValue}
          getValues={getValues}
        />

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button
            type="button"
            color="dark"
            outline
            onClick={onCancel}
            disabled={loading || isSubmitting}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            color="primary"
            outline
            disabled={loading || isSubmitting}
          >
            {(loading || isSubmitting) && <Spinner size="sm" className="me-2" />}
            Save
          </Button>
        </div>
      </form>
    </>
  );
};

export default AddEditTrainingGroup;
